import clienteAxios from "../config/axios";

export async function getAbmDistribucion() {
    return clienteAxios.get(`/abmDistribucion`);
}

export async function uploadAbmDistribucion() {
    return clienteAxios.post('/abmDistribucion/actualizar');
}

export async function getAbmSubcuentaDistribucion() {
    return clienteAxios.get(`/abmSubcuentaDistribucion`);
}

export async function getAbmSubcuentasDistribucionByCodDimAndCodDis(codDim, codDis) {
    return clienteAxios.get(`/abmSubcuentaDistribucionByCodDimAndCodDis/${codDim}/${codDis}`);
}